import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Grid,
  Typography,
  Select,
  MenuItem,
  Box,
  InputLabel,
  FormControl,
} from "@mui/material";
import { useState } from "react";

export default function AddProductPickingModal({ open, onClose, onConfirm }) {
  const [palletNumber, setPalletNumber] = useState("");
  const [shippedQty, setShippedQty] = useState("");

  const product = {
    sku: "GLUC2001",
    producto: "Glucosoral Durazno 24x15.3 Fl Oz",
    bin: "A-42",
    onHand: 50,
    cantidad: 10,
    imageUrl: "https://mayaland-src.s3.us-east-2.amazonaws.com/GLUC2001.jpg"
  };

  const handleConfirm = () => {
    onConfirm({
      pallet: palletNumber,
      quantityShipped: shippedQty,
    });
    setPalletNumber("");
    setShippedQty("");
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>Assign to Pallet</DialogTitle>
      <DialogContent>
        {product && (
          <Grid container spacing={2}>
            {product.imageUrl && (
              <Grid item xs={12} md={4} size={4}>
                <Box
                  component="img"
                  src={product.imageUrl}
                  alt={product.producto}
                  sx={{
                    width: "100%",
                    height: "auto",
                    borderRadius: 2,
                    objectFit: "contain",
                    maxHeight: 200,
                    mb: 2,
                  }}
                />
              </Grid>
            )}

            <Grid item xs={12} md={8} size={8}>
              <Grid container spacing={1}>
                <Grid item size={6}>
                    <Typography variant="h6" color="primary">
                      <strong>{product.sku}</strong>
                    </Typography>
                </Grid>
                <Grid item size={6} variant="subtitle1">
                  <Typography>
                    <strong>Bin:</strong> {product.bin || "-"}
                  </Typography>
                </Grid>
                <Grid item size={12}>
                    <Typography variant="h5">
                      {product.producto}
                    </Typography>
                </Grid>
                <Grid item size={6}>
                    <Typography variant="subtitle1">
                      <strong>On Hand:</strong> {product.onHand || 0}
                    </Typography>
                </Grid>
                <Grid item size={6}>
                  <Typography variant="subtitle1">
                    <strong>Quantity Ordered:</strong> {product.cantidad}
                  </Typography>
                </Grid>
                <Grid item size={6}>
                  <FormControl sx={{ m:1, minWidth: 120}}>
                    <InputLabel id="pallet-select-label">Pallet</InputLabel>
                    <Select
                      labelId="pallet-select-label"
                      id="pallet-select"
                      value={palletNumber || 1}
                      label="Pallet"
                      onChange={(e) => setPalletNumber(e.target.value)}
                      >
                        <MenuItem value={1}>1</MenuItem>
                        <MenuItem value={2}>2</MenuItem>
                        <MenuItem value={3}>3</MenuItem>
                        <MenuItem value={4}>4</MenuItem>
                        <MenuItem value={5}>5</MenuItem>
                      </Select>
                  </FormControl>
                </Grid>
                <Grid item size={6}>
                <FormControl sx={{ m:1, minWidth: 120}}>
                  <TextField
                    label="Quantity Shipped"
                    type="number"
                    fullWidth
                    value={shippedQty}
                    onChange={(e) => setShippedQty(e.target.value)}
                    InputProps={{
                      InputProps: {
                        min: 0
                      },
                    }}
                    onInput={(e) => {
                      const numericValue = e.target.value
                      if (!isNaN(numericValue) && numericValue < 0){
                        e.target.value = "0"
                      }
                    }}
                    />
                </FormControl>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button
          variant="contained"
          onClick={handleConfirm}
          disabled={!shippedQty}
        >
          Confirm
        </Button>
      </DialogActions>
    </Dialog>
  );
}
